module.exports = __webpack_public_path__ + "img/tipoboton02.e7e1d0c.svg";